export const REFERENCE_NAME_REQUIRED_ERROR = "Enter the reference's name";
export const SELECT_REQUIRED_ERROR = 'Select an option';
export const REFERENCE_CONTACT_NUMBER_REQUIRED_ERROR =
  "Enter the reference's mobile number";
